<template>
    <div>
        <div class="form-group">
            <input class="btn btn-outline-danger" type="button" value="Add new SN" @click="addItem">
        </div>
        <div class="form-group">
            <table class="table">
                <thead>
                    <tr>
                        <th>Product SN</th>
                        <th>Mistake Description</th>
                        <th class="d-none">Wish</th>
                        <th>Pictures</th>
                    </tr>
                </thead>
                <tbody>
                    <product-row v-for="(product, index) in products"
                         :key="index"
                         :wishes="wishes"
                         :product.sync="product">
                    </product-row>
                </tbody>
            </table>
        </div>
        <div class="form-group">
            <h5>{{$t('dispute.info')}}</h5>
            <textarea class="form-control mb-2" v-model="order.info"></textarea>
            <input class="btn btn-outline-danger" type="submit" @click="createDispute" value="Send Form">
        </div>
    </div>
</template>

<script>
import ProductRow from './ProductRow'
export default {
    components: {
        ProductRow
    },
    data() {
        return {
            note: '',
            dispute: Object,
            received: false,
            products:[]
        }
    },
    props: {
        order: {
            type: Object,
            default: {},
        },
        wishes: {
            type: Array,
            default: [],
        }
    },
    methods: {
        createDispute: function(){
            //TODO: error checking!!
            this.order.products = this.products;
            axios.post('/dashboard/disputes', {
                order: this.order,
            }).then(response => {
                //window.location.href = '/dashboard/disputes/'
            });
        },
        addItem: function() {
            var product = {
                sn:'',
                mistake:'',
                pictures: []
            };
            this.products.push(product)
        }
    },
    mounted() {
        //console.log(this.order);
        this.addItem();
    },
}
</script>


